export const DEFAULT_CURRENCY = "CAD";

export const VENUE_CUSTOM_FEE_TYPE_TAX_NAMES = {
  GST: {
    id: "1",
    name: "GST",
  },
  LST: {
    id: "2",
    name: "LST",
  },
  HST: {
    id: "3",
    name: "HST",
  },
  PST: {
    id: "4",
    name: "PST",
  },
  QST: {
    id: "5",
    name: "QST",
  },
  VAT: {
    id: "6",
    name: "VAT",
  },
  TAX: {
    id: "7",
    name: "TAX",
  },
  LET: {
    id: "8",
    name: "LET",
  },
  ADT: {
    id: "9",
    name: "Admissions Tax",
  },
  SALES: {
    id: "10",
    name: "Sales Tax",
  },
};
